import React from 'react';
import {
    Users, FileText, Search, Wrench,
    CheckCircle, Shield, Trophy, XCircle,
    ClipboardList, Target
} from 'lucide-react';

interface EightDTabNavigationProps {
    activeTab: number;
    setActiveTab: (index: number) => void;
}

export const EightDTabNavigation: React.FC<EightDTabNavigationProps> = ({
    activeTab,
    setActiveTab,
}) => {
    const tabs = [
        { id: 0, label: 'D0: Plan', icon: ClipboardList },
        { id: 1, label: 'D1: Team', icon: Users },
        { id: 2, label: 'D2: Problem', icon: FileText },
        { id: 3, label: 'D3: Contain', icon: Shield },
        { id: 4, label: 'D4: Root Cause', icon: Search },
        { id: 5, label: 'D5: PCA Plan', icon: Target },
        { id: 6, label: 'D6: Implement', icon: Wrench },
        { id: 7, label: 'D7: Prevent', icon: Shield },
        { id: 8, label: 'D8: Recognize', icon: Trophy },
        { id: 9, label: 'Admin: Close', icon: XCircle },
    ];

    return (
        <div className="bg-white rounded-t-xl border border-gray-200 border-b-0 overflow-x-auto">
            <div className="flex">
                {tabs.map((tab) => {
                    const Icon = tab.icon;
                    // Need complex mapping for completion checking if keys are reused
                    const isComplete = false; // Simplified for now

                    return (
                        <button
                            key={tab.id}
                            onClick={() => setActiveTab(tab.id)}
                            className={`flex items-center gap-2 px-4 py-3 border-b-2 transition-colors whitespace-nowrap ${activeTab === tab.id
                                ? 'border-blue-600 text-blue-600 bg-blue-50'
                                : 'border-transparent text-gray-600 hover:text-gray-900 hover:bg-gray-50'
                                }`}
                        >
                            <Icon className="w-4 h-4" />
                            <span className="font-medium">{tab.label}</span>
                            {isComplete && (
                                <CheckCircle className="w-4 h-4 text-green-600" />
                            )}
                        </button>
                    );
                })}
            </div>
        </div>
    );
};
